import { render } from "./PadelForm.vue?vue&type=template&id=e67eaa08&scoped=true&ts=true"
import script from "./PadelForm.vue?vue&type=script&lang=ts"
export * from "./PadelForm.vue?vue&type=script&lang=ts"

import "./PadelForm.vue?vue&type=style&index=0&id=e67eaa08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e67eaa08"]])

export default __exports__